import React, { useEffect, useState } from "react";

import SearchBar from "../../components/SearchBar/SearchBar";
import Carousel from "../../components/Carousel/Carousel";
import { Row, Container, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { cleanSearch } from "../../actions/searchActions";

import Axios from "../../services/Api";
import app_params from "../../config/params";
import description from "../../images/img-description.jpg";
import AdvancedSearchScreen from "../AdvancedSearchScreen/AdvancedSearchScreen";
import Alliances from "../../components/Aalliances/Alliances";
import Subscribe from "../../components/Suscribe/Subscribe";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
// import { library_info } from "../../data/homeInfo";

const HomeScreen = (props) => {
  const [lastAcquisitions, setLastAcquisitions] = useState({
    records: [],
    hasDetailPage: false,
  });
  // const [visitCount, setVisitCount] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(cleanSearch());
  }, [dispatch]);

  useEffect(() => {
    Axios.GetLatestAcquisitions()
      .then((res) => res.data)
      .then((data) =>
        setLastAcquisitions(
          data?.success ? data : { records: [], hasDetailPage: false }
        )
      )
      .catch((e) => {
        console.log(e);
        setLastAcquisitions({ records: [], hasDetailPage: false });
      });

    // Axios.GetVisits()
    //   .then((res) => res.data)
    //   .then((data) => setVisitCount(data?.success ? data?.count : 0))
    //   .catch((e) => {
    //     console.log(e);
    //     setVisitCount(0);
    //   });
  }, []);

  return (
    <>
      <div className="mx-0 px-3 px-md-4 px-xl-5 head">
        <div className="row col-12 d-flex justify-content-center mb-2">
          <div className="col-12 col-lg-8 col-xl-6 fist-section">
            <form action={`${app_params.basepath}/query`}>
              <SearchBar />
            </form>
          </div>
        </div>
        <div className="text-center">
          <button
            type="button"
            className="btn btn-lg btnSe"
            data-bs-toggle="modal"
            data-bs-target={`#advancedSearchModal`}
          >
            Búsqueda avanzada
          </button>
          {/* <a href={`${app_params.basepath}/advancedsearch`}>
          Búsqueda avanzada
        </a> */}
        </div>
      </div>
      <div className="mx-0 px-3 px-md-4 px-xl-5">
        <HeaderSection />
      </div>
      {/* MODAL DE BUSQUEDA AVANZADA */}
      <div className="modal fade" id="advancedSearchModal" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <AdvancedSearchScreen />
            </div>
          </div>
        </div>
      </div>
      <section className="container">
        {/* MODAL DE BUSQUEDA AVANZADA */}
        <Carousel
          title={"Reciente Ingreso"}
          items={lastAcquisitions?.records}
          hasDetailPage={lastAcquisitions?.hasDetailPage}
        />
      </section>
      <Alliances />
      {/* <section className="container">
        <div className="bg-white mx-0 mx-md-3 my-3 p-3">
          <div className="row p-2">
            <div className="col-12 text-center">
              Usted es el visitante # {visitCount}
            </div>
          </div>
        </div>
      </section> */}
      <section className="c-cirma-conectado">
        <Container>
          <Row>
            <Col className="c-mantcont">
              <h2>Mantente informado</h2>
            </Col>
          </Row>
          <Row>
            <Col className="c-desc">
              Recibe correos electrónicos con anuncios sobre nuevas colecciones,
              publicaciones, boletines, noticias y fechas de próximas
              exposiciones y eventos.
            </Col>
          </Row>
          <Row className="c-row-form">
            <Col className="c-col-form">
              <Subscribe />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default HomeScreen;
